import { Card } from "@material-tailwind/react";

export function HomeContent() {
  return (
    <div>
      <Card
        variant="filled"
        className="w-full h-screen text-center place-content-center mx-auto text-6xl font-bold"
      >
        Coming soon! <br />
        Under construction
      </Card>
    </div>
  );
}
